import { Tooltip } from '../../tooltip/Tooltip';
import { numFormatter } from '../../shared/utils/number/formatter';
import { NumFormattingType } from '../../shared/utils/number/interface';

export function RenderEventCell({
  count,
  showHyphenOnZero
}: {
  count: number;
  showHyphenOnZero?: boolean;
}) {
  if (count < 0 || (showHyphenOnZero && count === 0)) {
    return '-';
  }

  return (
    <Tooltip title={count} disabled={count < 1000} dataId=''>
      <span className='ml-auto'>{numFormatter(count, NumFormattingType.SHORT, false)}</span>
    </Tooltip>
  );
}
